import React from 'react'

type ArticleAnchorProps = {
  text?: string
  id?: string
}

type Anchor = {
  properties?: ArticleAnchorProps
}

type AnchorSectionProps = {
  title?: string
  anchors?: Anchor[]
}

type PageIntroductionBlock = {
  title?: string
  text?: string
  anchorList?: Anchor[]
}

export const Anchor = (props: ArticleAnchorProps) => {
  const { text, id } = props
  return (
    <div>
      <a
        className="u-fs-20 u-mb-24 d-block u-button-opacity"
        key={'link-item-' + id}
        href={'#' + id}
        style={{ lineHeight: '30px' }}>
        {text}
      </a>
    </div>
  )
}

export const AnchorsBlock = (props: AnchorSectionProps) => {
  const { anchors } = props

  return (
    <div>
      {props?.title && <p className="h2">{props?.title}</p>}
      <div>
        {anchors?.map(anchor => (
          <Anchor
            text={anchor.properties?.text}
            id={anchor.properties?.id}
            key={'anchor-' + anchor.properties?.id}></Anchor>
        ))}
      </div>
    </div>
  )
}

export const PageIntroductionBlock = (props: PageIntroductionBlock) => {
  const { title, text, anchorList } = props

  return (
    <div className="u-py-48 u-bg-white">
      <div className="container">
        {title && <h1>{title}</h1>}
        <div className="row">
          <div className="col-12 col-sm-8">
            {text && <p className="u-fs-lg-20 u-mb-16 u-mb-lg-0">{text}</p>}
          </div>
          <div className="col-12 col-sm-4 u-pl-sm-24">
            <ul className="ul-stripped">
              {anchorList?.map((item, id) => (
                <li className="u-mb-8 u-mb-lg-24" key={`${id}${item.properties?.id}`}>
                  <a className="u-fs-lg-20 u-button-opacity" href={'#' + item.properties?.id}>
                    {item.properties?.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
